import { useEffect, useState } from 'react';
import { useSearchParams } from '@direct-frontend/modules-router';
import { getRequestContext } from '@/shared/lib/requestContext';

interface UsePayboxSrcProps {
    orderId: string;
    merchantId?: string;
    storeName: string;
    legalUrl: string;
    amount: number;
    paymentMethods: string;
}

export const usePayboxSrc = (props: UsePayboxSrcProps) => {
    const { orderId, merchantId, storeName, legalUrl, amount, paymentMethods } = props;

    const {
        payboxHost,
        isExpressCheckout,
        company: { companyShopUrl },
    } = getRequestContext();
    const [searchParams] = useSearchParams();
    const from = searchParams.get('from');

    const [payboxSrc, setPayboxSrc] = useState('');

    useEffect(() => {
        if (payboxSrc || !orderId || !merchantId || !payboxHost) {
            return;
        }

        const params = new URLSearchParams({
            lang: 'ru',
            session_id: orderId,
            theme: 'LIGHT',
            payment_methods: paymentMethods,
            amount: String(amount),
            checkout_type: isExpressCheckout ? 'external' : 'internal',
            payment_widget_legal_store_name: storeName,
            payment_widget_legal_link: legalUrl,
        });

        if (merchantId) {
            params.append('merchant_id', merchantId);
        }

        if (from === 'shop') {
            params.append('payment_widget_user_agreement_link', `${companyShopUrl}/privacy`);
        }

        // eslint-disable-next-line react-hooks/set-state-in-effect -- выше есть проверка по payboxSrc
        setPayboxSrc(`${payboxHost}?${params.toString()}`);
    }, [
        payboxSrc,
        merchantId,
        orderId,
        amount,
        payboxHost,
        isExpressCheckout,
        storeName,
        legalUrl,
        from,
        companyShopUrl,
        paymentMethods,
    ]);

    return { payboxSrc, payboxHost };
};
